import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { BookStatus, IBook } from '../../../models/admin';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContainer, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-book-card',
  templateUrl: './book-card.component.html',
  styleUrls: ['./book-card.component.scss'],
  standalone: false
})
export class BookCardComponent {
  // Input
  @Input() book!: IBook;
  @Input() isLoading!: boolean;
  @Input() canEdit: boolean = false;
  @Input() canDelete: boolean = false;
  @Input() showEnabled: boolean = false;
  @Input() canManageSpellings: boolean = false;

  // Output
  @Output() edit = new EventEmitter<IBook>();
  @Output() delete = new EventEmitter<IBook>();
  @Output() click = new EventEmitter<IBook>();
  @Output() manageSpelling = new EventEmitter<IBook>();

  // For Keeping Track Of Hovering
  isHovered = false;
  UserBookStatusEnum = BookStatus;
  constructor(
    private router: Router,
    private dialog: MatDialog
  ) {

  }
  onEdit(event: Event, book: IBook) {
    event.stopPropagation();
    this.edit.emit(book);
  }

  onDelete(event: MouseEvent, book: IBook) {
    event.stopPropagation();
    event.preventDefault();

    const dialogRef = this.dialog.open(ConfirmDeleteBookDialogComponent, {
      width: '300px',
      data: { bookTitle: book.Title }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete.emit(book);
      }
    });
  }

  onManageSpellings(event: MouseEvent, book: IBook) {
    event.stopPropagation();
    event.preventDefault();
    this.manageSpelling.emit(book);
  }

  onCardClick(event: Event, book: IBook) {
    event.stopPropagation();
    this.click.emit(book);
  }

  showBookStatusIcon(status: BookStatus) {
    return (this.book.Status as any) === BookStatus[status];
  }
}

@Component({
  selector: 'app-confirm-delete-book-dialog',
  standalone: true,
  template: `
    <h2 mat-dialog-title class="warning-title">
      <mat-icon color="warn" class="warning-icon">warning</mat-icon>
      Delete Book
    </h2>

    <mat-dialog-content class="warning-content">
      Are you sure you want to delete <b>{{data.bookTitle}}</b>?
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close cdkFocusInitial>No</button>
      <button mat-button color="warn" (click)="onConfirm()">Yes</button>
    </mat-dialog-actions>
  `,
  styles: [`

    .warning-title {
      display: flex;
      align-items: center;
      color: #d32f2f;
      font-weight: 500;
      margin: 0;
    }

    .warning-icon {
      font-size: 24px;
      line-height: 1;
      vertical-align: middle;
    }

    .warning-content {
      margin-top: 8px;
    }
  `],
  imports: [
    MatDialogModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatIconModule
  ]
})
export class ConfirmDeleteBookDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteBookDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { bookTitle: string }
  ) { }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
